<template>
  <div class="pagination" v-if="isVisiblePaginations">
    <span
      class="pagination__arrow left"
      :class="{ active: pagesArrayIndex > 1 }"
      @click="prevPages"
    >
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 1L8 7L14 13M8 1L2 7L8 13" stroke-width="1.5" />
      </svg>
    </span>
    <span
      class="pagination__arrow left"
      :class="{ active: currentPage > 1 }"
      @click="prevPage"
    >
      <svg
        width="9"
        height="14"
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 1L2 7L8 13" stroke-width="1.5" />
      </svg>
    </span>
    <span
      v-for="index in currentPages"
      class="pagination__item"
      :class="{ active: index === currentPage }"
      @click="() => setcurrentPage(index)"
      :key="index"
      >{{ index }}</span
    >
    <span
      class="pagination__arrow right"
      :class="{ active: currentPage !== totalpages }"
      @click="nextPage"
    >
      <svg
        width="9"
        height="14"
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1L7 7L1 13" stroke-width="1.5" />
      </svg>
    </span>
    <span
      class="pagination__arrow right"
      :class="{ active: pagesArrayIndex < pagesArray.length }"
      @click="nextPages"
    >
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1L7 7L1 13" stroke-width="1.5" />
        <path d="M7 1L13 7L7 13" stroke-width="1.5" />
      </svg>
    </span>
  </div>
</template>

<script>
import { router } from '@src/routes';
import Vue from 'vue';

export default {
  data: function() {
    return {
      currentPage: 1,
      pages: null,
      pageEnd: 5,
      pagesArray: [],
      pagesArrayIndex: null,
    };
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    totalpages: {
      type: Number,
      default: 1,
    },
    maxpages: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    currentPages: function() {
      for (let i = 0; i < this.pagesArray.length; i++) {
        if (this.pagesArray[i].includes(this.currentPage)) {
          this.pagesArrayIndex = i + 1;
          return this.pagesArray[i].filter((item) => item);
        }
      }
      return [];
    },
    isVisiblePaginations: function() {
      return this.totalpages > 1;
    },
  },
  methods: {
    setcurrentPage: function(index) {
      this.currentPage = index;
      router.push({
        path: this.$route.fullPath,
        query: { page: this.currentPage },
      });
    },
    prevPage: function() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        router.push({
          path: this.$route.fullPath,
          query: { page: this.currentPage },
        });
      }
    },
    nextPage: function() {
      if (this.currentPage < this.totalpages) {
        this.currentPage += 1;
        router.push({
          path: this.$route.fullPath,
          query: { page: this.currentPage },
        });
      }
    },
    prevPages: function() {
      this.currentPage =
        this.pagesArray.filter((item) =>
          item.includes(this.currentPage)
        )[0][0] - this.maxpages;
    },
    nextPages: function() {
      this.currentPage =
        this.pagesArray.filter((item) =>
          item.includes(this.currentPage)
        )[0][0] + this.maxpages;
    },
    createPages: function() {
      let n = 1;

      const blocks = Math.ceil(this.totalpages / this.maxpages);

      this.pagesArray = new Array(blocks);

      for (let i = 0; i < blocks; i++) {
        this.pagesArray[i] = new Array(this.maxpages);
      }

      for (let i = 0; i < blocks; i++) {
        for (let q = 0; q < this.maxpages && n <= this.totalpages; q++) {
          this.pagesArray[i][q] = n;
          n++;
        }
      }
    },
  },
  created() {
    this.pages = Array.from(Array(this.totalpages + 1).keys()).splice(1);
    this.createPages();
  },
  mounted() {
    this.currentPage = this.page;
  },
};
</script>

<style lang="sass" scoped>
@import './src/sass/params.sass'

.pagination
  display: flex
  align-items: center
  user-select: none
  &__item
    width: 48px
    border-radius: 50%
    font-size: 18px
    line-height: 48px
    text-align: center
    cursor: pointer
    transition: all .2s

    &.active
      color: #FFFFFF
      background-color: #5599DD
      &:hover
        color: #FFFFFF
    &:hover
      color: #5599DD
  &__arrow
    opacity: 0
    pointer-events: none
    svg
      width: 18px
      height: 12px
      stroke: #939596
    &.active
      pointer-events: all
      opacity: .5
      cursor: pointer

      &:hover
        svg
          opacity: .8
          stroke: #58595A
    &.left
      margin-right: 32px
    &.right
      margin-left: 32px
  @media screen and ( max-width: 1279px )
    &__item
      width: 40px
      font-size: 16px
      line-height: 40px
    &__arrow
      svg
        width: 16px
        height: 10px
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/pagination.vue